import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import './star-rating.css';

const StarRating = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (rating >= i) {
      stars.push(<FaStar key={i} className="star-rating" />);
    } else if (rating >= i - 0.5) {
      stars.push(<FaStarHalfAlt key={i} className="star-rating" />);
    } else {
      stars.push(<FaRegStar key={i} className="star-rating" />);
    }
  }

  return <div style={{ display: "flex", gap: "4px", width: "fit-content" }}>{stars}</div>;
};

export default StarRating;
